var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocIconDetailsPage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.9998 0.5C10.6733 0.5 13.6655 3.4922 13.6655 7.16573C13.6655 8.65996 12.8123 10.4443 12.2561 11.4778L7.59007 20.1433C7.51428 20.2876 7.38844 20.399 7.23624 20.4566C7.08388 20.5145 6.91588 20.5145 6.76352 20.4566C6.61133 20.399 6.48548 20.2876 6.40969 20.1433L1.74368 11.4778C1.1874 10.4445 0.334232 8.66012 0.334232 7.16573C0.334232 3.4922 3.32643 0.5 6.99996 0.5H6.9998ZM6.9998 1.83322C4.0468 1.83322 1.66722 4.21277 1.66722 7.1658C1.66722 8.05977 2.42683 9.92272 2.92402 10.8458L6.99964 18.4142L11.0757 10.8458C11.5727 9.92256 12.3323 8.05977 12.3323 7.1658C12.3323 4.21281 9.95276 1.83322 6.99972 1.83322H6.9998ZM6.9998 3.61079C8.95528 3.61079 10.5549 5.21041 10.5549 7.16592C10.5549 9.12144 8.95548 10.7211 6.9998 10.7211C5.04432 10.7211 3.44467 9.12144 3.44467 7.16592C3.44467 5.21041 5.04412 3.61079 6.9998 3.61079ZM6.9998 4.94402C5.76485 4.94402 4.77789 5.93098 4.77789 7.16592C4.77789 8.40087 5.7647 9.38783 6.9998 9.38783C8.23475 9.38783 9.22171 8.40087 9.22171 7.16592C9.22171 5.93098 8.23475 4.94402 6.9998 4.94402Z",
    fill: "#707372"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocIconDetailsPage);
export default __webpack_public_path__ + "static/media/loc-icon-details-page.acef868f4cc52c4588c77edc955aeb11.svg";
export { ForwardRef as ReactComponent };